export default {
  apiKey: 'cbf029ae0e6637f1f81e3681ed45055d806a37298458a036194a7fe00f4ba8ae',
  customerId: '220742',
};
